import { useAppSelector } from "app/hooks";
import { selectJobSeekerRolesInCommunity, selectAdminInCommunitiesSelectList } from 'features/job-seeker-auth';
import { selectUser } from "features/auth";
import { selectJobSeekerOnBehalfOfOrganizationAdminId } from "features/job-seeker-on-behalf-of-organization-admin";
import { Roles, MemberRoles } from "features/types";
import { getAdminRoleInCommunity } from 'utils/job-seeker-on-behalf-of-organization-helper';
import RedirectToHomePage from 'components/RedirectToHomePage';

type Props = {
  children: React.ReactNode;
  roles: (Roles | MemberRoles)[];
  elseRedirectToHome?: boolean;
  elseChildren?: React.ReactNode;
  validateOrgnizationContext?: boolean;
};

const ShowForRoles = ({ children, roles, elseChildren, validateOrgnizationContext, elseRedirectToHome }: Props) => {
  const user = useAppSelector(selectUser);
  const onBehalfOfOrganizationAdminId = useAppSelector(selectJobSeekerOnBehalfOfOrganizationAdminId);
  const jobSeekerRolesInCommunity = useAppSelector(selectJobSeekerRolesInCommunity);
  const isAdminInCommunitiesSelectList = useAppSelector(selectAdminInCommunitiesSelectList);

  const jobSeekerRoles: MemberRoles[] = [];
  if (roles.includes(MemberRoles.FullAdmin) || roles.includes(MemberRoles.ViewOnlyAdmin)) {
    if (typeof validateOrgnizationContext === 'boolean') {
      if (onBehalfOfOrganizationAdminId) {
        const adminRoleInCommunity = getAdminRoleInCommunity(onBehalfOfOrganizationAdminId, isAdminInCommunitiesSelectList);
        if (adminRoleInCommunity) jobSeekerRoles.push(adminRoleInCommunity as unknown as MemberRoles);
      } else if (jobSeekerRolesInCommunity.includes(MemberRoles.Member)) {
        jobSeekerRoles.push(MemberRoles.Member);
      }
    } else if (typeof validateOrgnizationContext === 'undefined') {
      jobSeekerRoles.push(...jobSeekerRolesInCommunity);
    }
  }

  if ((user && roles.includes(user.role)) || jobSeekerRoles.some(role => roles.includes(role))) {
    return <>{children}</>;
  }
  if (elseRedirectToHome) return <RedirectToHomePage />;
  if (elseChildren) return <>{elseChildren}</>;
  return null;
};

export default ShowForRoles;
